import { render, staticRenderFns } from "./status-form-accounts.vue?vue&type=template&id=40e3f3b2&scoped=true&"
import script from "./status-form-accounts.vue?vue&type=script&lang=js&"
export * from "./status-form-accounts.vue?vue&type=script&lang=js&"
import style0 from "./status-form-accounts.vue?vue&type=style&index=0&id=40e3f3b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e3f3b2",
  null
  
)

export default component.exports